import makeRequest from './client';
import { WhatsNewAdminPayload } from '../components/WhatsNewRegain/types';

const baseURL = `/whats-new/admin`;

export const getWhatsNewRegainConfig = () => makeRequest(baseURL, 'GET');

export const updateWhatsNewRegainConfig = (payload: WhatsNewAdminPayload) =>
  makeRequest(baseURL, 'PUT', payload);
